import Link from "next/link";
import CustomSigningOfferModal from "../../components/modal/CustomSigningOfferModal";
import { useState } from "react";

const Hero = ({ block }: { block: any }) => {
  const [showCustomSigningOfferModal, setShowCustomSigningOfferModal] =
    useState(false);

  return (
    <section className="hero">
      <video className="video" autoPlay muted>
        <source src="/signo_wise.mp4" type="video/mp4" />
      </video>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <img
              src="/images/signowise-hu/logo-black.svg"
              className="logo"
              alt="logo"
            />
            <div className="hero__text">
              <h3>Biometrikus e-aláírás</h3>
              <h4>Több mint kétmillió magyar felhasználó</h4>
              <ul>
                <li>
                  Takaríts meg szerződésenként akár 15 percet és 1000 Ft-ot
                  papírmentes személyes ügyintézéssel!
                </li>
                <li>
                  Több mint 2 millió OTP banki ügyfél által is használt
                  elektronikus aláírási termékünk a KKV-d számára is elérhető.
                </li>
                <li>
                  Érintőképernyőn aláírni pont olyan, mint papíron, így az
                  ügyfeleid számára gördülékeny az átállás.
                </li>
              </ul>
              <button
                className="btn"
                onClick={() => setShowCustomSigningOfferModal(true)}
              >
                Érdeklődöm{" "}
                <img src="/images/signowise-hu/arrow-btn.svg" alt="arrow-btn" />
              </button>
              <CustomSigningOfferModal
                showModal={showCustomSigningOfferModal}
                setShowModal={setShowCustomSigningOfferModal}
                block={block}
              />
            </div>
          </div>
          <div className="col-lg-6"></div>
        </div>
        <div className="row">
          <Link href="#advantages" className="scroll">
            <div className="scroll-downs">
              <div className="mousey">
                <div className="scroller"></div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
